import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import N5ContentLayout from './jlpt/n5/N5ContentLayout';
import N4ContentLayout from './jlpt/n4/N4ContentLayout';
import N3ContentLayout from './jlpt/n3/N3ContentLayout';
import N2ContentLayout from './jlpt/n2/N2ContentLayout';
import N1ContentLayout from './jlpt/n1/N1ContentLayout';

// Single source of truth for JLPT levels
const levelContents = {
  n5: <N5ContentLayout />,
  n4: <N4ContentLayout />,
  n3: <N3ContentLayout />,
  n2: <N2ContentLayout />,
  n1: <N1ContentLayout />
};

export default function JlptHome({ defaultLevel = '/' }) {
  const [selected, setSelected] = useState(defaultLevel);
  const location = useLocation();

  useEffect(() => {
    // Extract level from pathname (n1, n2, n3, n4, or n5)
    const level = location.pathname.match(/n[1-5]/)?.[0];
    if (level && levelContents[level]) {
      setSelected(level);
    }
  }, [location]);

  return (
    <div>
      <div>
        {levelContents[selected] || levelContents[defaultLevel]}
      </div>
    </div>
  );
}